import { useTranslations } from "next-intl";
import dynamic from "next/dynamic";
import Image from "next/image";
import { FC, useContext, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import Icon from "@/components/ui/Icon/Icon";
import { MagnifyContext } from "@/context/MagnifyContext";
import useMediaQuery from "@/hooks/useMediaQuery";
import { CommercetoolsUnit } from "@/types";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "../ui/Button/Button";

const Modal = dynamic(() => import("@/components/ui/Modal/Modal"), { ssr: false });
const ModalContent = dynamic(() => import("@/components/ui/Modal/ModalContent"), { ssr: false });

export type FloorPlanProps = {
  unit: CommercetoolsUnit;
};

const FloorPlan: FC<FloorPlanProps> = ({ unit }) => {
  const t = useTranslations();
  const [floorModalOpen, setFloorModalOpen] = useState<boolean>(false);
  const [tourModalOpen, setTourModalOpen] = useState<boolean>(false);
  // const floors = unit?.floorPlan ? [...unit?.floorPlan].reverse() : [];

  const { openZoomModalWithImage } = useContext(MagnifyContext);

  return (
    <>
      <div className="flex justify-between">
        <h3 className="font-primary font-medium text-xs uppercase mb-l">{t("unit.floorPlan")}</h3>
        {unit?.virtualTourUrl && (
          <div>
            <Button
              onClick={() => setTourModalOpen(true)}
              rounded
              size={ButtonSize.SMALL}
              theme={ButtonTheme.WHITE}
              type="button"
              variant={ButtonVariant.PRIMARY}
              customClass="mr-m"
            >
              <Icon name="3d" title="3D" size="16" className="stroke-black" />
            </Button>
            {/* <Button
            rounded
            size={ButtonSize.SMALL}
            theme={ButtonTheme.WHITE}
            type="button"
            variant={ButtonVariant.PRIMARY}
            onClick={() => setFloorModalOpen(true)}
          >
            <Icon name="full-screen" title="full screen" size="16" className="stroke-black" />
          </Button> */}
          </div>
        )}
      </div>
      <div className="flex items-center justify-start">
        {unit.unitPlan && (
          <div className="cursor-pointer" onClick={() => openZoomModalWithImage(unit.unitPlan)}>
            <Image src={unit.unitPlan} width={400} height={400} alt={t("unit.plan")} className="max-h-5xl md:max-h-[500px] w-full object-contain" />
          </div>
        )}
        {/* TODO: should this be a list? */}
        {/* <Swiper
          direction="vertical"
          slidesPerView={1}
          spaceBetween={6}
          initialSlide={floors.length}
          className="mt-xs !mx-0 w-[calc(100%-100px)] max-h-[25vh] md:max-h-[none]"
          modules={[Pagination, Navigation]}
          navigation={{
            nextEl: `#button-next-${unit.id}`,
            prevEl: `#button-prev-${unit.id}`,
          }}
          autoHeight={isDesktop ? true : false}
          pagination={{
            clickable: true,
            el: `#pagination-${unit.id}`,
            renderBullet: function (index, className) {
              let bullet = '<span class="!flex items-center justify-center my-xxs ' + className + '">' + floors[index].floor + "</span>";
              return bullet;
            },
          }}
        >
          {floors.map((plan, i) => (
            <SwiperSlide key={`floor-plan-${i}`} className="!h-auto">
              <Image src={plan.image.url} width={400} height={400} alt={plan.image.title} className="w-full object-contain" />
            </SwiperSlide>
          ))}
        </Swiper> 
        <div className="px-l text-center my-xs ">
          <span className="text-xs font-secondary mb-xs inline-block">{t("aul.viewFloor")}</span>
          <div id={`button-prev-${unit.id}`} className="relative mb-xxs">
            <button className="">
              <Icon className="stroke-black" name="chevron-up" size="20" />
            </button>
          </div>
          <div id={`pagination-${unit.id}`} className="relative floor-plan-pagination flex flex-col items-center"></div>
          <div id={`button-next-${unit.id}`} className="relative mt-xxs">
            <button className="">
              <Icon className="stroke-black" name="chevron-down" size="20" />
            </button>
          </div>
        </div>*/}
      </div>
      {/* {floorModalOpen &&
        {
          
        }} */}
      {unit?.virtualTourUrl && (
        <Modal
          open={tourModalOpen}
          onClose={() => {
            setTourModalOpen(false);
          }}
        >
          <ModalContent className="w-full h-full !rounded-none  py-l">
            <div className="flex justify-between pb-l">
              <h2 className="font-medium uppercase font-primary text-m ">{t("unit.3dtourmodal")}</h2>
              <Button
                className="modal__close"
                size={ButtonSize.MEDIUM}
                variant={ButtonVariant.TERTIARY}
                theme={ButtonTheme.BLACK}
                onClick={() => setTourModalOpen(false)}
              >
                <span className="pointer-events-none">
                  <Icon name="close" size="24" title="close" className="stroke-black" />
                  <span className="sr-only">{t("button.label.close")}</span>
                </span>
              </Button>
            </div>
            <iframe
              className="object-cover w-full h-[calc(100dvh-100px)] rounded-lg border-0"
              width="560"
              height="315"
              src={unit?.virtualTourUrl}
              title="3d Tour"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
            ></iframe>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default FloorPlan;
